/**
 * 统一的 Int64 字符串归一化工具。
 * - 只接受字符串输入
 * - 只接受数字字符
 * - 默认拒绝 0（包含 "0"/"000"）
 * - 可通过 allowZero 仅放行严格的 "0"
 */
export function normalizeInt64IdOrThrow(rawId, fieldName, options = {}) {
  const { allowZero = false } = options

  if (typeof rawId !== 'string') {
    throw new Error(`${fieldName} 非法`)
  }

  const normalized = rawId.trim()
  if (!/^\d+$/.test(normalized)) {
    throw new Error(`${fieldName} 非法`)
  }

  if (/^0+$/.test(normalized)) {
    if (allowZero && normalized === '0') {
      return '0'
    }
    throw new Error(`${fieldName} 非法`)
  }

  return normalized
}

export function normalizeInt64IdOrNull(rawId, options = {}) {
  try {
    return normalizeInt64IdOrThrow(rawId, 'id', options)
  } catch {
    return null
  }
}

export function toInt64MapKey(id) {
  return String(id)
}
